import i18n from '../i18n';

/**
 * 获取桌台状态
 * - 代码转文本(国际化)
 * @param table_status 桌台状态（null/-1/0/1未开台，2开台，3已送厨，4已打预结单但未付款，5付款超时，6停用）
 */
export function getTableStatusText(table_status: -1 | 0 | 1 | 2 | 3 | 4 | 5 | 6 | null) {
    switch (table_status) {
        case null:
        case -1:
        case 0:
        case 1:
            return i18n.t('google_text_have_not_open')
        case 2:
            return i18n.t('google_text_have_open')
        case 3:
            return i18n.t('google_text_food_had_delivered')
        case 4:
            return i18n.t('google_text_had_printed_advanced_payment')
        case 5:
            return i18n.t('google_text_payment_timed_out')
        case 6:
            return i18n.t('google_text_disable')
        default:
            return '';
    }
}